import React from 'react';
import { CnLayoutCell as UICnLayoutCell } from "../../components/cn-layout";
import { enableDivider } from "./enhance/callbacks";
var CnLayoutCell = function CnLayoutCell(props) {
  var _ref = props || {},
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UICnLayoutCell, {
    style: {
      height: '100%'
    },
    onClick: function onClick() {
      enableDivider();
    }
  }, children);
};
CnLayoutCell.displayName = 'CnLayoutCell';
export default CnLayoutCell;
export { CnLayoutCell };